import React from 'react';
import "./footer.css"

function Footer() {
  return (
    <div className='footer'>
        <p> Air BnB clone, No rights Reserved @this-is-a-demo</p>
        <p>Privacy- terms- sitemap- Company Details</p>
      
    </div>
  )
}

export default Footer
